import core_auth_jwt_useJwt from '@core/auth/jwt/useJwt';
import axios from '@axios';


const {
  jwt
} = core_auth_jwt_useJwt(axios, {});
export default (jwt);

